import { Alert, Button, Flex, Text, TextInput } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import cn from "classnames";
import { UserCreateWithPasswordDto } from "definitions/poizon-sso";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Form, useNavigate } from "react-router-dom";
import { appConfig } from "src/config";
import { useRedirectUrl } from "src/hooks";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { loginRequest } from "src/store/fetchers/loginRequest";

import { notificationAtom } from "../store/notification";
import css from "./LoginPage.module.scss";

export const LoginPage = () => {
  const { forwardRedirectUrl } = useRedirectUrl();

  const navigate = useNavigate();
  const [notification, setNotification] = useAtom(notificationAtom);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserCreateWithPasswordDto>({
    mode: "onChange",
  });

  const [isLoading] = useAtom(loginRequest.isLoadingAtom);
  const onSubmit: SubmitHandler<UserCreateWithPasswordDto> =
    useAction(loginRequest);
  const [tempNotification] = useState(() => notification);

  useEffect(() => {
    setNotification({ theme: "info", message: "" });
  }, [setNotification]);

  useEffect(() => {
    const origin = window.location.origin;
    // @ts-expect-error eslint-disable-line
    window.YaAuthSuggest.init(
      {
        client_id: "f42a7f4fcb8c4471ad3afa21cb5cd33b",
        response_type: "token",
        redirect_uri: origin + "/authorization/yaAuth",
      },
      origin,
      {
        view: "button",
        parentId: "buttonContainerId",
        buttonSize: "s",
        buttonView: "main",
        buttonTheme: "light",
        buttonBorderRadius: "10",
        buttonIcon: "ya",
      },
      // @ts-expect-error eslint-disable-line
    ).then(({ handler }) => handler());
  });

  return (
    <Flex className={cn(css.main, css.full)}>
      <Flex className={cn(css.main, css.mainContainer)}>
        {tempNotification.message && (
          <Alert
            theme={tempNotification.theme}
            title="Внимание"
            message={tempNotification.message}
          />
        )}

        <Flex className={css.main}>
          <appConfig.logo
            height={50}
            onClick={() => navigate(RoutesPaths.LANDING)}
            className={css.footerLogo}
          />
          <Text variant="display-1">Авторизуйтесь</Text>
        </Flex>
        <Form className={css.loginForm} onSubmit={handleSubmit(onSubmit)}>
          <div className={css.loginFormInputContainer}>
            <TextInput
              placeholder="email"
              {...register("email", {
                required: "Обязательное поле",
                pattern: {
                  value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: "Некорректный email",
                },
              })}
              size="xl"
              label="Почта"
              validationState={errors.email ? "invalid" : undefined}
              errorMessage={errors.email?.message}
              errorPlacement="outside"
            />
          </div>
          <div className={css.loginFormInputContainer}>
            <TextInput
              placeholder="пароль"
              {...register("password", {
                required: "Обязательное поле",
              })}
              size="xl"
              label="Пароль"
              type="password"
              validationState={errors.password ? "invalid" : undefined}
              errorMessage={errors.password?.message ?? "1"}
              errorPlacement="outside"
            />
          </div>

          <div id="buttonContainerId" />

          <Flex
            className={css.loginFormInputContainer}
            direction={"column"}
            alignItems={"center"}
            gap={"3"}
          >
            <Button
              view="action"
              size="l"
              type="submit"
              loading={isLoading}
              width="max"
            >
              Войти в личный кабинет
            </Button>
            <Flex direction="row" gap="3">
              <div
                className={css.linkLabel}
                onClick={() =>
                  navigate(forwardRedirectUrl(RoutesPaths.AUTH.RESTORE))
                }
              >
                Забыл пароль
              </div>
              <div
                className={css.linkLabel}
                onClick={() =>
                  navigate(forwardRedirectUrl(RoutesPaths.AUTH.REG))
                }
              >
                Регистрация
              </div>
            </Flex>
          </Flex>
        </Form>
      </Flex>
    </Flex>
  );
};
